<template>
  <div class="data-grid__files">
    <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]">
      <ul v-if="cellDisplayVal">
        <li v-for="file of cellDisplayVal" :key="file.key">
          <b-badge variant="success" :href="file.url" target="_blank">
            {{ file.name }}
            &nbsp;
            <a
              href="#"
              @click.stop.prevent="deleteFile(file.key, file.name)"
              class="data-grid__files _delete"
            >
              <icon v-if="!controlInfo.readonly" name="remove" style="vertical-align: -3px;" />
            </a>
          </b-badge>
        </li>
      </ul>
      <div v-if="!controlInfo.readonly">
        <a
          href="#"
          v-if="$can('update', 'Dashboard_' + currentDash)"
          @click.prevent="showAddFilesModal"
        >
          <icon name="cloud-upload" />
          <span>Upload</span>
        </a>
      </div>
    </div>
    <div v-else>
      <ul v-if="cellDisplayVal">
        <li v-for="file of cellDisplayVal" :key="file.key">
          <b-badge :href="file.url" target="_blank" variant="success">{{ file.name }}</b-badge>
        </li>
      </ul>
    </div>
    <AddFilesModal
      ref="addFilesModal"
      :gridId="gridId"
      :rowKey="rowKey"
      :cellKey="cellKey"
      :options="options"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { pull as lodashPull } from 'lodash'
// components
import AddFilesModal from '../../modals/AddFiles'
// services
import db from '@/services/db'
import storage from '@/services/storage'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'cellDisplayVal',
    'options',
    'gridId',
    'widgetKey',
    'editMode',
    'controlInfo',
  ],
  components: {
    AddFilesModal,
  },
  computed: {
    ...mapState(['currentDash', 'dgRowInEditMode']),
  },
  methods: {
    showAddFilesModal() {
      this.$refs.addFilesModal.open()
    },
    deleteFile(key, name) {
      if (!confirm('Are you sure?')) return

      storage.delete(this.currentDash, `${key}_${name}`, async err => {
        if (err) return

        const curFileIds = this.cellVal.split(',')
        const newFileIds = lodashPull(curFileIds, key)

        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value: newFileIds.join(',') || null,
        }

        await db.dataGrid.data.saveCellVal(data)

        db.files.delete(key)
      })
    },
  },
}
</script>

<style lang="scss">
@import '~$scss/globals';

.data-grid__files {
  ul {
    @include resetList;
    li {
      margin-bottom: 3px;
    }
  }
  &._delete:hover {
    color: #fb6340;
  }
}
</style>
